<template lang="pug">
.weather
  //- Barra de navegación
  van-nav-bar(:title="$t('weather.title')")
    van-icon(name="menu" slot="left" @click="openSidenav")

  //- Sección principal
  .main(v-if="installations")

    //- Listado de instalaciones
    .units__installations(
      v-for="(installation, installationKey) in installations"
      :key="installationKey")

      //- Fila de instalación
      .units__installations__bar
        .units__installations__name {{ installation.name }}

      //- Fila del clima
      van-cell-group(v-if="installation.weather")
        van-cell(
          :title="installation.weather.currently.summary"
          :value="parseTemp(installation.weather.currently.temperature, installation.units)")
</template>

<script>
import { UnitFilter } from '@/filters/Temp.filter';
import { mapGetters, mapActions } from 'vuex';

export default {
  filters: { UnitFilter },
  computed: {
    ...mapGetters({
      getInstallations: 'unitsModule/getInstallations',
    }),

    /**
     * Devuelve todas las instalaciones
     */
    installations() {
      return this.getInstallations();
    },
  },

  methods: {
    ...mapActions({
      openSidenav: 'globalModule/openSidenav',
    }),

    parseTemp(value, unit) {
      const units = this.$options.filters.UnitFilter(unit);
      if (!value) return `-- ${units}`;
      return `${value} ${units}`;
    },
  },
};
</script>
